import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../api";

function DetailReport() {
  const query = new URLSearchParams(useLocation().search);
  const [data, setData] = useState([]);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  useEffect(() => {
    axiosInstance
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/api/DashboardReport/GetDetails?type=${query.get(
          "type"
        )}&year=${query.get("year")}&month=${query.get("month")}`
      )
      .then((res) => {
        setData(res.data);
      })
      .catch(console.log);
  }, []);

  return (
    <section>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
              <blockquote>Sr.No.</blockquote>
              <blockquote>Quotation Id</blockquote>
              <blockquote>Total Amount To Pay</blockquote>
              <blockquote>Amount Paid</blockquote>
              <blockquote>Month</blockquote>
              <blockquote>Year</blockquote>
              <blockquote>Enquiry Type</blockquote>
            </aside>
          </div>
          <div>
            {data.length > 0 ? (
              data.map((x, i) => (
                <aside style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
                  <blockquote>{i + 1}</blockquote>
                  <blockquote>{x.quotationId}</blockquote>
                  <blockquote>
                    {x.symbol} {Math.round(x.totalAmountToPay)}
                  </blockquote>
                  <blockquote>
                    {x.symbol} {Math.round(x.amountPaid)}
                  </blockquote>
                  <blockquote>{months[x.month - 1]}</blockquote>
                  <blockquote>{x.year}</blockquote>
                  <blockquote>{x.enquiryType}</blockquote>
                </aside>
              ))
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 7" }}>
                  <center>No Records Found</center>
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
    </section>
  );
}

export default DetailReport;
